import { createSlice } from '@reduxjs/toolkit';

import type { RegistroCitacaoState } from '../../types/registroCitacao';
import { registrarCitacaoParte } from './actions';

const initialState: RegistroCitacaoState = {
  registrando: false,
  erro: null,
};

const registroCitacaoSlice = createSlice({
  name: 'secretariaArbitralRegistroCitacao',
  initialState,
  reducers: {
    limparErroRegistroCitacao(state) {
      state.erro = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registrarCitacaoParte.pending, (state) => {
        state.registrando = true;
        state.erro = null;
      })
      .addCase(registrarCitacaoParte.fulfilled, (state) => {
        state.registrando = false;
      })
      .addCase(registrarCitacaoParte.rejected, (state, action) => {
        state.registrando = false;
        state.erro = action.payload ?? action.error.message ?? 'Erro ao registrar a citação';
      });
  },
});

export const { limparErroRegistroCitacao } = registroCitacaoSlice.actions;
export const secretariaArbitralRegistroCitacaoReducer = registroCitacaoSlice.reducer;
